import { NativeClient } from "@realestate.com.au/webview";
import { ResponsiveLayout } from "./responsiveLayout";

export { NativeClient } from "@realestate.com.au/webview";
export type Client = NativeClient | "web";
export type PlatformName =
  | "iphoneapp"
  | "ipadapp"
  | "android"
  | "outdated_app"
  | "web"
  | "msite";
export type RenderedOn = "webview" | "browser";

export type Platform = {
  getName: () => PlatformName;
  getRenderedOn: () => RenderedOn;
};

type PlatformArgs = {
  nativeClient: NativeClient | undefined;
  responsiveLayout: ResponsiveLayout;
};

const NATIVE_PLATFORM_MAPPINGS: { [key: string]: PlatformName } = {
  iphone: "iphoneapp",
  ipad: "ipadapp",
  android: "android",
  outdated_app: "outdated_app",
};

const RENDERED_ON_MAPPINGS: { [key: string]: RenderedOn } = {
  iphone: "webview",
  ipad: "webview",
  android: "webview",
  outdated_app: "webview",
  web: "browser",
};

export const createPlatform = ({
  nativeClient,
  responsiveLayout,
}: PlatformArgs): Platform => {
  return {
    getName: (): PlatformName => {
      if (nativeClient) {
        return NATIVE_PLATFORM_MAPPINGS[nativeClient];
      }
      const isDesktopBrowser = responsiveLayout === "XL";
      return isDesktopBrowser ? "web" : "msite";
    },
    getRenderedOn: (): RenderedOn =>
      RENDERED_ON_MAPPINGS[nativeClient || "web"],
  };
};
